require('ta-semantic-ui/semantic/dist/components/icon.css');
require('ta-semantic-ui/semantic/dist/components/button.css');
require('ta-semantic-ui/semantic/dist/components/input.css');
require('ta-semantic-ui/semantic/dist/components/message.css');
require('ta-semantic-ui/semantic/dist/components/accordion.css');

require('./identificator.styl');
require('./search.css');

import React from 'react';
import Autosuggest from 'react-autosuggest';

const cityQuarters = require('json!./data/cityData.json');
const quarterList = require('json!./data/quarters.json');

// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = value => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  return inputLength === 0 ? [] : cityQuarters.filter(lang =>
    lang.name.toLowerCase().slice(0, inputLength) === inputValue
  );
};

// When suggestion is clicked, Autosuggest needs to populate the input element
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion.name + ' (' + suggestion.circle + ')';

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
  <div>
    {`${suggestion.name} (${suggestion.circle})`}
  </div>
);

class Identificator extends React.Component {

    constructor(props) {
        super(props);

      this.toggleList = this.toggleList.bind(this);
      this.selectedOnList = this.selectedOnList.bind(this);

      this.state = {
          quarterList: quarterList,
          showMessageIfNotCitizen: false,
          isLoading: false,
          suggestions: [],
          value: '',
          selectedQuarter: '',
          showQuarterList: false
        }
    }

    onChange = (event, { newValue }) => {
      this.setState({
        value: newValue
      });
    };

    toggleList = (e) => {
      this.setState({
        showQuarterList: !this.state.showQuarterList
      });
    }

    selectedOnList(quarter,circle) {

      let suggestion = {
        circle: 'Kreis '+circle,
        name: quarter
      }

      // console.log(suggestion);

      this.setState({
        selectedQuarter: suggestion,
        showQuarterList: true
      })

      window.scrollTo(0, window.innerHeight);

      // console.log(window.innerHeight+'px')

      this.props.clickHandler(suggestion,true,true);

    }

    onSuggestionSelected = (event, { suggestion }) => {

      this.setState({
        selectedQuarter: suggestion,
        readerMadeHisChoice: true
      });

      // console.log(suggestion)

      this.props.clickHandler(suggestion,true,true);


    };



      // Autosuggest will call this function every time you need to update suggestions.
    // You already implemented this logic above, so just use it.
    onSuggestionsFetchRequested = ({ value }) => {
      this.setState({
        suggestions: getSuggestions(value)
      });
    };

    // Autosuggest will call this function every time you need to clear suggestions.
    onSuggestionsClearRequested = () => {
      this.setState({
        suggestions: []
      });
      // this.props.clickHandler(this.state.value,true,true)
    };

    resetSelection = () => {
      this.setState({
        selectedQuarter: '',
        value: '',
        showQuarterList: false
      });
      // suggestion => suggestion.name + ' (' + suggestion.circle + ')';
      this.props.clickHandler('',true,false)
    }

    render() {
      const { value, suggestions } = this.state;

      // Autosuggest will pass through all these props to the input element.
      const inputProps = {
        placeholder: 'Suchen Sie Ihr Stadtquartier..',
        value,
        onChange: this.onChange,
        type: 'search'
      };

      let appendTableRow = (v,i) => {
        // console.log(v)

        let quarter= v.quarterId;
        let circle = v.circle;

        return(
          <tr
            className='hover-table'
            onClick={ () => this.selectedOnList(quarter,circle) }
            data-id={v.quarterId}
          >
            <td>Kreis {v.circle}</td>
            <td>{v.quarterName}</td>
          </tr>
        )
      }


            return (

            <div className='identificator wrapper'>

                <div className='ui vertical very fitted segment text-center'>
                    <div className='ui message identificator'>
                        <p className='identificator question title'>Wohnen Sie in der Stadt Zürich?</p>
                        <button
                            className={`ui green basic large button ${
                                this.props.readerIsCityCitizen ? 'active' : ''
                                }`}
                            onClick={ ()=> this.props.clickHandler('', true, this.state.selectedQuarter ? true : false) }
                        >
                            Ja
                        </button>
                        <button
                            className={`ui red basic large button ${
                                !this.props.readerIsCityCitizen && this.props.readerMadeHisChoice ? 'active' : ''
                                }`}
                            onClick={ ()=> this.props.clickHandler('', false, true) }
                        >
                            Nein
                        </button>

                        { !this.props.readerIsCityCitizen && this.props.readerMadeHisChoice &&

                            <p><i className='icon info circle'> </i> Sie sehen eine allgemeine Version des Textes. Einzig einige Daten auf Quartierniveau werden im Text nicht eingeblendet.
                            </p>

                        }

                        { this.props.readerIsCityCitizen &&
                            <div>
                              { this.props.readerMadeHisChoice == false &&
                              <p
                                className='search-label'
                                style={{
                                  fontSize: '0.9em',
                                  color: 'grey'
                                }}
                              >
                                <span style={{
                                  fontSize: '1.2em',
                                  color: 'black'
                                }}>
                                  In welchem <strong>Stadtquartier</strong> wohnen Sie?</span><br/>Keine PLZ eingeben. <a
                                href='https://de.wikipedia.org/wiki/Stadtteile_der_Stadt_Z%C3%BCrich#Statistische_Quartiere_und_Zonen'
                                target='_blank'>Hier gehts zur Definition der Statistischen Quartiere der Stadt Zürich</a>
                              </p>
                              }

                              { this.props.readerMadeHisChoice == true &&
                                <br/>
                              }
                                <div className='ui large icon input'>

                                  {/*<input type='text' placeholder='Quartier suchen...'></input>*/}

                                  { this.state.selectedQuarter == '' &&
                                    < Autosuggest
                                      suggestions={suggestions}
                                      onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                      onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                      getSuggestionValue={getSuggestionValue}
                                      renderSuggestion={renderSuggestion}
                                      inputProps={inputProps}
                                      onSuggestionSelected={this.onSuggestionSelected}
                                      focusFirstSuggestion={true}
                                    />
                                  }

                                </div>

                              { this.state.selectedQuarter == '' &&


                              <div
                                className='ui styled accordion'
                              >
                                <div
                                  onClick={ this.toggleList }
                                  className='title'
                                  style={{
                                    fontFamily: 'Benton Sans Cond',
                                    marginTop: '10px'
                                  }}
                                >
                                  <i className={`caret icon ${this.state.showQuarterList ? 'down' : 'right'}`}></i>
                                  Liste aller Stadtquartiere
                                </div>
                                {this.state.showQuarterList == true &&
                                  <div className='quarterlist-content'>
                                    <table className='ui fixed single line celled selectable very compact table'>
                                      <thead>
                                      <tr>
                                        <th>Kreis</th>
                                        <th>Statistisches Quartier</th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                        {
                                          this.state.quarterList.map(appendTableRow)
                                        }
                                      </tbody>
                                    </table>
                                  </div>
                                }
                              </div>

                              }

                                { this.state.selectedQuarter &&

                                  <div className='selection reset box'>
                                    <p>
                                      <span
                                        className='bentonLight'
                                        style={{fontSize: '0.9em'}}
                                      >
                                        Sie wohnen im Quartier </span>
                                      <span
                                        className='bentonFat'
                                      >
                                        {this.state.selectedQuarter.name}
                                      </span>
                                      <i
                                        className='icon remove red'
                                        onClick={this.resetSelection}
                                      >
                                      </i>
                                    </p>
                                  </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
    );

    }

}

Identificator.defaultProps = {};

Identificator.propTypes = {
  readerIsCityCitizen: React.PropTypes.bool,
  clickHandler: React.PropTypes.func,
  readerMadeHisChoice: React.PropTypes.bool,
  onSuggestionSelected: React.PropTypes.func,
  changeChosenQuarter: React.PropTypes.func
}

export default Identificator;



// WEBPACK FOOTER //
// ./src/components/identificator/Identificator.js